<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<p class="SP"> </p>
<p class="Dedication-ded"><span epub:type="pagebreak" id="pg_vii" title="vii"><span class="ePub-I">To the real Charlotte and Rose, my grandmothers, whose names I borrowed for this book and whose memories I will forever cherish</span></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?4fb4c744